import PropTypes from 'prop-types';
import { DEFAULT_LANGUAGE_CODE, LANGUAGES } from 'shared/constants';
import { propTypes as UserPropTypes, defaultProps as UserDefaultProps } from './User';

export const defaultProps = {
  loggingIn: false,
  loggingOut: false,
  loggedOut: null,
  loggedIn: false,
  user: UserDefaultProps,
  token: null,
  error: null,
  language: DEFAULT_LANGUAGE_CODE,
  company: null,
  companies: []
};

const authCompanyProps = PropTypes.shape({
  id: PropTypes.string,
  slug: PropTypes.string,
  name: PropTypes.string,
  logo: PropTypes.string,
  agency: PropTypes.bool,
});

export const propTypes = {
  loggingIn: PropTypes.bool,
  loggingOut: PropTypes.bool,
  loggedOut: PropTypes.bool,
  loggedIn: PropTypes.bool,
  user: PropTypes.shape(UserPropTypes),
  token: PropTypes.string,
  error: PropTypes.string,
  language: PropTypes.oneOf(LANGUAGES),
  company: authCompanyProps,
  companies: PropTypes.arrayOf(authCompanyProps)
};

export default { defaultProps, propTypes };
